import { createReducer, createTypes } from 'reduxsauce';

export const aplicacaoTypes = createTypes(
  `
      SET_THINGS_DATA
      SET_VELOCIMETRO_DATA
      SET_REALTIME_DATA
      SET_ENERGY
      SET_OPERATIONAL_STATUS
      RESET
  `,
  { prefix: 'APLICACAO/' }
);

const INITIAL_STATE = {
  energy: null,
  realtimeData: {},
  ucha: {},
  velocimetro: {},
  operationalStatus: [],
};

// Reducers
const setThingsData = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    ...action.data,
  };
};

const setRealtimeData = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    realtimeData: {
      [action.thing]: {
        ...action.data,
      },
    },
  };
};

const setEnergy = (state = INITIAL_STATE, action) => {
  return { ...state, energy: action.data };
};

const setVelocimetro = (state = INITIAL_STATE, action) => {
  return { ...state, velocimetro: { ...state.velocimetro, ...action.data } };
};

const setOperationalStatus = (state = INITIAL_STATE, action) => {
  return { ...state, operationalStatus: action.data };
};

const reset = () => INITIAL_STATE;

export default createReducer(INITIAL_STATE, {
  [aplicacaoTypes.SET_THINGS_DATA]: setThingsData,
  [aplicacaoTypes.SET_REALTIME_DATA]: setRealtimeData,
  [aplicacaoTypes.SET_ENERGY]: setEnergy,
  [aplicacaoTypes.SET_VELOCIMETRO_DATA]: setVelocimetro,
  [aplicacaoTypes.SET_OPERATIONAL_STATUS]: setOperationalStatus,
  [aplicacaoTypes.RESET]: reset,
});
